import './../scss/style.scss';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

// init lenis!
import { lenis } from "./scrolling";
import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common';
// import { initCookies } from './shared/cookies';
import { initOffcanvas } from './shared/offcanvas';
import { initScrollTo } from './shared/scroll-to';
import { initVideo } from './shared/video';
import { initImageZoom } from './shared/image-zoom';
import { initASwap } from './aswap';
import { initLoading } from './loading';

// register gsap plugins
gsap.registerPlugin(ScrollTrigger);

WCAG.init();
initCommon();
// initCookies();
initOffcanvas();
initScrollTo();
initVideo();
initImageZoom();
// loading
initLoading();
// initASwap();
// setTimeout(() => {
//   document.documentElement.classList.remove("index-loading");
// }, 50);


